<template>
    <p-feature-flag
      name="Pay In Pay Out"
      redirect>
      <p-search-screen
        title="Pay-In / Pay-Out"
        api-destination="payinpayouts"
        edit-key="specialItemId"
        :filters="filters"
        :fields="fields"
        :filterBy="filterBy"
        add-new-button
      >
      </p-search-screen>
    </p-feature-flag>
  </template>
  
  <script>
  import SearchStorage from '@/components/mixins/SearchFilterStorage.js';
  import {booleanToYesNoFormatter} from "@/components/Common/Formatters.js";
  
  export default {
    mixins: [SearchStorage],
    data() {
      return {
        filterName: 'payinpayoutsFilter',
        filters: {
          automatic: "",
          perPage: 100,
          sortBy: 'name',
          sortDesc: true,
          searchBy:'All'
        },
        filterBy:[
            'All',
            'Name',
            'Type'
        ],
        fields: [
          {
            key: "name",
            sortable: true
          },
          {
            key: "type"
          },
          {
            key: "requiresMerchantReceipt",
            formatter: booleanToYesNoFormatter
          },
          {
            key: "requiresAccount",
            formatter: booleanToYesNoFormatter
          },
          {
            key: "isActive",
            disabled: true
          }
        ]
      };
    }
  };
  </script>
  
  